import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=cc0fc96a&scoped=true"
import script from "./Layers.vue?vue&type=script&lang=js"
export * from "./Layers.vue?vue&type=script&lang=js"
import style0 from "./Layers.vue?vue&type=style&index=0&id=cc0fc96a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0fc96a",
  null
  
)

export default component.exports